<template>
  <ui-select :model-value="selectValue" :disabled="disabled" @update:model-value="(value) => select(value)">
    <ui-select-trigger
      data-slot="lead-assignee-select"
      size="sm"
      :class="[ 'w-full min-w-0', !assignee && 'text-muted-foreground' ]"
      :aria-label="tr('Assignee')"
      @click.stop
    >
      <loader-circle-icon v-if="loading" class="size-3.5 animate-spin" />
      <ui-select-value :placeholder="tr('Unassigned')" />
    </ui-select-trigger>
    <ui-select-content @click.stop>
      <ui-select-item :value="UNASSIGNED">{{ tr('Unassigned') }}</ui-select-item>
      <ui-select-item v-for="option in options" :key="option.id" :value="option.id">
        {{ option.fullname }}
      </ui-select-item>
    </ui-select-content>
  </ui-select>
</template>

<script>
import { LoaderCircle } from '@lucide/vue';

// The kit select works with non-empty strings.
const UNASSIGNED = 'unassigned';

export default {
  name: 'LeadAssigneeSelect',
  components: {
    LoaderCircleIcon: LoaderCircle,
  },
  props: {
    assignee: {
      type: Object,
      default: null,
    },
    // The company members: { id, fullname }.
    members: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: [ 'update:assignee' ],
  data: () => ({
    UNASSIGNED,
  }),
  computed: {
    selectValue() {
      return this.assignee?.id ?? UNASSIGNED;
    },
    // A former member assigned earlier stays visible.
    options() {
      const options = [ ...this.members ];
      if (this.assignee?.id && !options.some(option => option.id === this.assignee.id)) {
        options.unshift({ id: this.assignee.id, fullname: this.assignee.fullname });
      }

      return options;
    },
  },
  methods: {
    select(value) {
      const userId = value === UNASSIGNED ? null : value;
      if (userId !== (this.assignee?.id ?? null)) {
        this.$emit('update:assignee', userId);
      }
    },
  },
};
</script>
